import React from 'react';
import { connect } from 'react-redux';
import { list } from '~/actions/orderNew';
import Tag from '~/components/Tag';
import { IconButton } from 'react-toolbox/lib/button';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <div>Pick a order</div>
            {Object.keys(this.props.items).map(id => <Tag
              type="order"
              id={id}
              key={id}
              style={{ margin: '5px 5px 0 0' }}
              onClick={() => {
                this.props.data.onChange(id);
                this.context.dialogClose(this.props.dialogId);
              }}
            />)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.getIn(['orderNew', 'items']).toJS(),
});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/OrderPick/index.js